$(document).ready(function () {

    if ($('.slick-galerie').length) {
        $('.slick-galerie').each(function () {
            let slider = $(this);
            slider.slick({
                dots: false,
                arrows: true,
                fade: false,
                autoplay: false,
                slidesToShow: 3,
                centerMode: false,
                slidesToScroll: 1,
                infinite: true,
                appendArrows: slider.parent().find('.slick-arrows'),
                prevArrow: '<div class="slide-arrow prev-arrow"><i class="fa-thin fa-arrow-left-long"></i></div>',
                nextArrow: '<div class="slide-arrow next-arrow"><i class="fa-thin fa-arrow-right-long"></i></div>',
                autoplaySpeed: 3000,
                responsive: [
                    {
                        breakpoint: 1400,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    }
                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object
                ]
            });
        });
    }

    $('.bttn__autoplay-video').mouseenter(function () {
        $(this).parent().find('video').css('z-index', '1');
        $(this).parent().find('video').trigger('play');
    });

    $('video').mouseleave(function () {
        $(this).css('z-index', '-1');
        $(this).trigger('pause');
    });

    $('.slick-galerie').lightGallery({
        selector: '.lightgallery',
        thumbnail: false,
        share: false,
        rotate: false,
        download: false
    });

    $('.bttn__open-gallery').click(function () {
        $(this).closest('section').find('img[data-src]:first-child').trigger('click');
    });
});
